<div class="container">
    <div class="row">
        <div class="col-12 text-center">
            <h1 i18n>Acceso operadores</h1>
        </div>
    </div>
</div>
<div class="login-box">
    <div class="container">
        <div class="row">
            <div class="col-md-6 login-right">
                <div class="row">
                    <div class="col-12">
                        <h3 i18n>Accede a la gestión a la ciudadanía a través de</h3>
                    </div>
                    <div class="col-12">
                        <div class="row text-center">
                            <a class="link-primary clickable" (click)="loginPrivate()" i18n>idCat</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>